module.exports = __webpack_public_path__ + "static/media/t17.ca6d90a5.jpg";